import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getCustomerProfileData } from '../../Redux/action/Admin/CustomerAction';

import { adminMainUrl } from "../../Config.jsx";

const Declaration = ({ handleBack, handleNext, activeStep, CustomerProfileData, refresh }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const dispatch = useDispatch();
  const [filePreview, setFilePreview] = useState(null);
  const customertoken = Cookies.get('customertoken');


  let initialValues = {

    creditPeriodDays: "",
    totalCreditLimit: "",
    declaration: null,
    cancelledCheque: "",

  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      creditPeriodDays: Yup.number()
        .min(0, 'Credit period days must be greater than or equal to 0'),

      totalCreditLimit: Yup.number()
        .min(0, 'Total credit limit must be greater than or equal to 0'),

      declaration: Yup.boolean()
        .oneOf([true], 'Pleace check the field.'), // Ensure declaration is always true

      cancelledCheque: Yup.string()
        .required('Cancelled cheque is required') // Ensure cancelled cheque is required
    }),
    onSubmit: (values, { resetForm }) => {
      setDisable(true);
      try {


        let config = { headers: { "auth-token": token, 'content-type': 'multipart/form-data', } }


        axios.post(`${adminMainUrl}/api/customer-profile/update-declaration`, values, config)
          .then(res => {
            if (res.status === 200) {
              refresh();
              toast.success(res.data.msg);
              setDisable(false);
              dispatch(getCustomerProfileData(token))
              handleNext();
            } else {
              toast.error(res.data.msg);
              setDisable(false);
            }
          }).catch(err => {
            console.log(err);
            if (err.response) {
              toast.error(err.response.data.msg);
            } else {
              toast.error("Internal server error.")
            }
            setDisable(false);
          });

      } catch (error) {
        console.log(error);
        toast.error(error.response.data.msg);
        setDisable(false);
      }
    }
  });

  const token = Cookies.get('customertoken')
  // useEffect(() => {


  //   dispatch(getCustomerProfileData(token))

  // }, [token]);

  // let {
  //   loadingCustomerProfileDataApi,
  //   CustomerProfileDataError,
  //   CustomerProfileData
  // } = useSelector(state => state?.CustomerReducer);


  useEffect(() => {
    if (CustomerProfileData) {
      formik.setValues({
        creditPeriodDays: CustomerProfileData?.creditPeriodDays ?? "",
        totalCreditLimit: CustomerProfileData?.totalCreditLimit ?? "",
        cancelledCheque: CustomerProfileData?.cancelledCheque ?? "",
        declaration: CustomerProfileData?.declaration ? true : false
      });

      // If there's a pre-existing cancelledCheque value, set the preview for it
      if (CustomerProfileData?.cancelledCheque) {
        setFilePreview(`${adminMainUrl}/${CustomerProfileData.cancelledCheque}`); // Set the image preview
      }
    }
  }, [CustomerProfileData]);

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first file
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error("Please upload a valid image file.");
        formik.setFieldValue('cancelledCheque', null); // Reset formik field value
        setFilePreview(null); // Reset preview URL
        return; // Exit the function
      }
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Max allowed file size is 10MB.");
        return; // Exit the function if the file is too large
      }
      formik.setFieldValue('cancelledCheque', file); // Update formik field value
      setFilePreview(URL.createObjectURL(file)); // Set the preview URL
    }
  };


  return (
    <>
      {/* <Toaster /> */}
      {

        <div id="section2" className="section2">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Credit Period Required by Party in Days
                  </label>
                  <input
                    type="number"
                    min={0}
                    max={9999}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='creditPeriodDays'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.creditPeriodDays}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Total Credit Limit Required by Party in
                    numeric figure (In Lacs)
                  </label>
                  <input
                    type="number"
                    min={0}
                    max={999999999}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='totalCreditLimit'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.totalCreditLimit}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="basicpill-firstname-input" className="form-label">
                    Copy of Cancelled Cheque<span className="text-danger">*</span>
                  </label>
                  <div className="custom-file-container">
                    <label className="custom-file-container__custom-file">
                      <i className="fa-solid fa-upload"></i> Upload Files
                      <input
                        type="file"
                        className="custom-file-container__custom-file__custom-file-input d-none"
                        name='cancelledCheque'
                        accept="image/*" // Ensure only image files are selected
                        onChange={handleFileChange}
                        onBlur={formik.handleBlur}
                      />
                      <span className="custom-file-container__custom-file__custom-file-control"></span>
                    </label>
                  </div>
                  <div className="help-block with-errors">
                    {formik.errors.cancelledCheque ? (
                      <div className="text-danger small">{formik.errors.cancelledCheque}</div>
                    ) : null}
                  </div>

                  {/* Image preview section */}
                  {filePreview && (
                    <div className="image-preview mt-2">
                      <img src={filePreview} alt="Preview" className="img-thumbnail" style={{ width: '200px', height: 'auto' }} />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <input id="checkbox" type="checkbox"
                  name='declaration'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.declaration}
                  checked={formik.values.declaration}
                /> I/We
                hereby declare that the particulars given
                herein above are true, correct and complete
                to the best of my/our knowledge and belief,
                the documents submitted in support of this
                Form, KYC are genuine and obtained legally
                from the respective issuing authority. In
                case of any change in any of the
                aforementioned particulars, I/we undertake
                to notify you in writing failing which the
                above particulars may be relied upon
                including all shipments/documents executed
                and tendered by the individual so authorized
                and mentioned above. I/we hereby authorize
                you to submit the above particulars to the
                customs and other regulatory authorities on
                my/our behalf as may be required in order to
                transport and customs clear my/our
                shipments.
              </div>
              <div className="help-block with-errors">
                {formik.errors.declaration ? (
                  <div className="text-danger small">{formik.errors.declaration}</div>
                ) : null}
              </div>
            </div>
            <Paper className='h-100 d-flex flex-col justify-content-between' square elevation={0} >

              <div className='button-container d-md-flex justify-content-between w-100' style={{ marginTop: '20px' }}>
                <Button
                  type="button"
                  disabled={disable}
                  onClick={handleBack}
                  sx={{ mt: 1, mr: 1 }}
                  className='btn-stepper btn btn-primary'
                >
                  Previous
                </Button>
                <Button
                  type="submit"
                  className='btn-stepper btn btn-primary'
                  variant="contained"
                  // onClick={handleNext}
                  sx={{ mt: 1, mr: 1 }}
                  disabled={disable}
                >
                  {!disable ? "Next" : <i className="fas fa-spinner fa-spin" style={{ color: "#fff" }}></i>}
                </Button>
              </div>
            </Paper>
          </form>
        </div >

      }
    </>

  )
}

export default Declaration